import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgReport = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M22.685 1.813c.495 0 .896.4.896.896v18.78a.898.898 0 0 1-.024.207.896.896 0 0 1-.71 1.092l-.162.014H7.032a.896.896 0 0 1-.161-1.776l.16-.015H21.79V9.666H3.372v5.76a.896.896 0 0 1-1.777.16l-.014-.16V2.709c0-.495.401-.896.896-.896ZM16.517 13.08l.124.101 2.263 2.207a.896.896 0 0 1-1.125 1.384l-.125-.102-1.632-1.59-3.437 3.433a.896.896 0 0 1-1.112.123l-.14-.11-2.69-2.576-5.53 5.59a.896.896 0 0 1-1.142.11l-.124-.103a.896.896 0 0 1-.11-1.142l.103-.124 6.151-6.215a.896.896 0 0 1 1.132-.117l.124.1 2.69 2.576 3.446-3.436a.896.896 0 0 1 1.134-.11Zm5.273-9.477H3.372v4.27H21.79v-4.27Zm-2.136 1.24a.896.896 0 0 1 .161 1.777l-.16.014H5.082a.896.896 0 0 1-.161-1.776l.16-.015h14.572Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgReport)
const Memo = memo(ForwardRef)
export default Memo
